<form (click)="debugForm(constructor.name)" (keydown)="(null)">
  <mat-form-field class="w-[calc(100%-64px)]">
    <mat-label class="text-xl font-semibold">Devise préférée</mat-label>
    <mat-select [formField]="formTree.currency">
      @for (currency of currencies; track currency.code) {
        <mat-option [value]="currency.code">{{ currency.name }}</mat-option>
      }
    </mat-select>
    <mat-error>Devise invalide</mat-error>
  </mat-form-field>
</form>
